import './App.css';
import Footer from '../shared/components/layout/Footer';
import DashboardFooter from '../shared/components/layout/DashboardFooter';
import ParticleBackground from '../shared/components/layout/ParticleBackground';
import Topbar from '../shared/components/layout/Topbar';
import AppRoutes from './router/AppRouter';
import useAppController from '../shared/hooks/useAppController';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useSelector } from 'react-redux';
import { isPublicRoute, isStoreRoute } from './router/routes';

function App() {
  const apiBase = process.env.REACT_APP_API_BASE || '';
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
  const storeName = useSelector((state) => state.store.storeName);
  const {
    auth,
    route,
    isStoreLoggedIn,
    request,
    bootstrapSession,
    sessionBootstrapComplete,
    sessionExpiredAt,
    handleAuthChange,
    handleStoreLogout,
    handlePushActivity
  } = useAppController(apiBase);
  const dashboardRoute = isStoreRoute(route);
  const marketingRoute = isPublicRoute(route);
  const authFullscreenRoute = route === '/login' || route === '/register' || route.startsWith('/register/');
  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <div className="app">
        <ParticleBackground
          variant={route === '/' ? 'pixel' : (dashboardRoute && isStoreLoggedIn ? 'uniform' : 'pixel-soft')}
        />

        <Topbar
          role={auth.role}
          authToken={auth.token}
          showStoreMenu={isStoreLoggedIn}
          onStoreLogout={handleStoreLogout}
          variant={dashboardRoute ? 'dashboard' : 'marketing'}
          storeName={storeName}
          route={route}
        />
        <AppRoutes
          request={request}
          bootstrapSession={bootstrapSession}
          sessionBootstrapComplete={sessionBootstrapComplete}
          onAuthChange={handleAuthChange}
          onPushActivity={handlePushActivity}
          sessionExpiredAt={sessionExpiredAt}
        />
        {dashboardRoute ? <DashboardFooter /> : null}
        {!dashboardRoute && marketingRoute && route !== '/' && !authFullscreenRoute ? <Footer /> : null}
      </div>
    </GoogleOAuthProvider>
  );
}

export default App;
